import Icon from '@material-ui/icons/Smartphone';
import List from './List';

export {
  Icon,
  List,
};



// WEBPACK FOOTER //
// ./src/components/PushNotificationRegistration/index.js